import { GraphqlParams } from '@shared/models/graphql';
import { Entity } from '../../types';
import { ExportOptions } from '@shared/models/export-options';
import { Task } from 'app/shared/modules/tasks/tasks.types';

export namespace EntityActions {
  export class Search {
    static readonly type = '[Jupiter] Search';

    constructor(public params: GraphqlParams) {}
  }

  export class Load {
    static readonly type = '[Jupiter] Load Entity';

    constructor(public id: number) {}
  }

  export class LoadTransient {
    static readonly type = '[Jupiter] Load Transient Entity';

    constructor(public id: number) {}
  }

  export class ClearTransient {
    static readonly type = '[Jupiter] Clear Transient Entity';

    constructor() {}
  }

  export class Delete {
    static readonly type = '[Jupiter] Delete Entity';

    constructor(
      public id: number,
      public forceDelete = false,
    ) {}
  }

  export class Clear {
    static readonly type = '[Jupiter] Clear Entity';

    constructor() {}
  }

  export class Update {
    static readonly type = '[Jupiter] Update Entity';

    constructor(public entity: Entity) {}
  }

  export class UpdateEntityTemplate {
    static readonly type = '[Jupiter] Update Entity Template';

    constructor(public templateId: number) {}
  }

  export class Add {
    static readonly type = '[Jupiter] Add Entity';

    constructor(public entity: Entity) {}
  }

  export class ClearData {
    static readonly type = '[Jupiter] Clear Data';

    constructor() {}
  }

  export class Export {
    static readonly type = '[Jupiter] Export Data';

    constructor(
      public params: GraphqlParams,
      public exportOptions: ExportOptions,
    ) {}
  }

  export class Duplicate {
    static readonly type = '[Jupiter] Duplicate Entity';

    constructor() {}
  }

  export class SetEntity {
    static readonly type = '[Jupiter] Set Entity';

    constructor(public entity: Entity) {}
  }

  export class GenerateMergeDocument {
    static readonly type = '[Jupiter] Generate Merge Document';

    constructor(public data: { fileResourceId: number; format: string; sendToDocusign: boolean }) {}
  }

  export class UpdateAvatar {
    static readonly type = '[Jupiter] Update Avatar';

    constructor(public file: File) {}
  }

  export class DeleteAvatar {
    static readonly type = '[Jupiter] Delete Avatar';

    constructor() {}
  }

  export namespace ImageActions {
    export class Add {
      static readonly type = '[Jupiter] Add Image to Entity';

      constructor(
        public entity: Entity,
        public image: File,
      ) {}
    }

    export class Delete {
      static readonly type = '[Jupiter] Delete Image of Entity';

      constructor(public id: number) {}
    }
  }

  export namespace EngagementActions {
    export class Load {
      static readonly type = '[Jupiter] Load Engagements';

      constructor(public mode: 'onlyEngagements' | 'all' = 'all') {}
    }

    export class Delete {
      static readonly type = '[Jupiter] Delete Engagement';

      constructor(public id: number) {}
    }
  }

  export namespace DealActions {
    export class Load {
      static readonly type = '[Jupiter] Load Deals';

      constructor(public fields: string[]) {}
    }

    export class Create {
      static readonly type = '[Jupiter] Create Deal';

      constructor(public model: any) {}
    }
  }

  export namespace PropertyActions {
    export class Load {
      static readonly type = '[Jupiter] Load Properties';

      constructor(public fields: string[]) {}
    }

    export class Create {
      static readonly type = '[Jupiter] Create Property';

      constructor(public model: any) {}
    }
  }

  export namespace LoanQuoteActions {
    export class Load {
      static readonly type = '[Jupiter] Load LoanQuotes';

      constructor(public fields: string[]) {}
    }
  }

  export namespace ContactActions {
    export class Load {
      static readonly type = '[Jupiter] Load Contacts';

      constructor(public fields: string[]) {}
    }

    export class Create {
      static readonly type = '[Jupiter] Create Contact';

      constructor(public model: any) {}
    }
  }
}
